<div class="payment-info">
  <div class="header-wrapper">
    <h3>Payment Method</h3>
    <p class="powered-by"><img src="../../../../assets/images/question-img.png" alt="Question">Powered by Cash App</p>
  </div>
  <ul>
    <li><img src="../../../../assets/images/shield.png" alt="secured"> Your payment is secured and encrypted</li>
    <li><img src="../../../../assets/images/timer.png" alt="timer"> Points are instantly credited to your account</li>
    <li><img src="../../../../assets/images/question.png"> 24/7 customer support available</li>
  </ul>
</div>
